module.exports = __webpack_public_path__ + "img/vertical_4_4_5012.e52fdcb9.png";